<template>
    <div class="bg-muted py-4 md:py-8">
        <AppContainer>
            <div class="flex items-center">
                <span class="flex-1 md:flex-none text-black text-lg font-bold">Explore manufacturers</span>
                <AppButton :href="route('brands.index')" class="!w-auto md:ml-4" size="small">
                    View all
                </AppButton>
            </div>

            <div class="grid gap-4 grid-cols-2 md:grid-cols-3 lg:grid-cols-6 mt-8">
                <BrandImage
                    v-for="brand of brands"
                    :brand="brand"
                ></BrandImage>
            </div>
        </AppContainer>
    </div>
</template>

<script>
import AppButton from '@/Components/AppButton.vue';
import BrandImage from '@/Components/Brands/BrandImage.vue';
import AppContainer from "@/Layouts/AppContainer";

export default {
    components: {
        AppContainer,
        AppButton, BrandImage
    },
    props: {
        brands: Array
    }
}
</script>

<style scoped>

</style>
